import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'

import Header from 'components/common/Header'

const LegalPage = ({
  children,
  heading,
}: {
  children: ReactNode
  heading: string
}) => {
  return (
    <div>
      <Header />

      <div className="mx-auto my-20 max-w-[960px] space-y-10 px-4 text-body-sm sm:my-4 sm:max-w-full sm:space-y-4">
        <h1 className="text-k/36_110 sm:text-k/20_110">{heading}</h1>

        {children}
      </div>
    </div>
  )
}

export default LegalPage

export const ExternalLink = (
  props: AnchorHTMLAttributes<HTMLAnchorElement>
) => {
  return <a {...props} className="text-orange-1 underline" />
}

export const UnderlinedLink = (props: LinkProps) => {
  return <Link {...props} className="text-orange-1 underline" />
}
